// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"input-radio_checkbox__H_fDS"};